import React from 'react'
import PropTypes from 'prop-types'

function CommonBtn({ isProgressBtn, isIconBtn, icon, className, value, style, onClick, textRight, textLeft, type, disabled }) {
    if (isProgressBtn) {
        return (
            <button onClick={onClick} type={type ? type : 'button'} className={className} style={style} disabled={disabled}>{value}</button>
        )
    } else if (isIconBtn) {
        return (
            <button onClick={onClick} type={type ? type : 'button'} className={className} style={style} disabled={disabled}>{textLeft ? textLeft + ' ' : ''}{icon}{textRight ? ' ' + textRight : ''}</button>
        )
    } else {
        return (
            <button onClick={onClick} type={type ? type : 'button'} className={className} style={style} disabled={disabled}>{value}</button>
        )
    }

}

CommonBtn.propTypes = {
    value: PropTypes.string,
    className: PropTypes.string,
    isProgressBtn: PropTypes.bool,
    isIconBtn: PropTypes.bool,
    style: PropTypes.object,
    onClick: PropTypes.func,
    icon: PropTypes.element,
    textRight: PropTypes.string,
    textLeft: PropTypes.string,
    type: PropTypes.string,
    disabled: PropTypes.bool,
}

CommonBtn.defaulProps = {
    value: '',
    className: 'btn',
    isProgressBtn: false,
    isIconBtn: false,
    style: {},
    onClick: () => { },
    icon: <></>,
    textRight: '',
    textLeft: '',
    type: 'button',
    disabled: false,
}


export default CommonBtn